export enum EVENT_RESULT_TYPES {
  RPE = "rpe",
  DROP_JUMP = "drop-jump",
  CMJ = "cmj",
  SYSTEM_TEST = "system-test",
}

export enum EVENT_RESULT_SKIP_MOTIVATION {
  INJURY = "injury",
  PERSONAL_PROBLEMS = "personal-problems",
  OTHER = "other",
}

export enum EVENT_RESULT_UNITS {
  IN = "in",
  CM = "cm",
}

export enum EVENT_RESULT_CALC_TYPES {
  AVERAGE = "average",
  PEAK = "peak",
}
